import { AfterViewInit, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.scss'],
})
export class ValidationMessageComponent implements AfterViewInit {
  @Input()
  form!: FormGroup;

  @Input()
  field!: string;

  @Input()
  showErrors: boolean = false;

  ngAfterViewInit() {
    if (!this.form.controls[this.field]) {
      console.warn(`${this.field} was not initilized in form group.`);
    }
  }
}
